var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "flex items-center py-3 border-b",
        _vm.dataFormat === "distribution" ? "pl-6" : "px-6"
      ],
      style: {
        width:
          _vm.dataFormat === "distribution" && _vm.tasks
            ? _vm.tasks.length < 8
              ? "100%"
              : _vm.tasks.length >= 9 && _vm.tasks.length < 10
              ? "calc(100vw - 27rem)"
              : _vm.tasks.length >= 10 && _vm.tasks.length < 11
              ? "calc(100vw - 20rem)"
              : "calc(100vw - 2rem)"
            : ""
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "flex items-center flex-shrink-0 w-32 px-2 bg-pure-white"
        },
        [
          _c("BlTextBody1", {
            attrs: { text: _vm.getDateWithoutTimezone(_vm.entry.recorded_at) }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.dataFormat !== "distribution" && _vm.dataFormat !== "cumulative"
        ? _c(
            "div",
            { staticClass: "flex flex-shrink-0" },
            _vm._l(_vm.getFilteredTasks(), function(task) {
              return _c(
                "div",
                {
                  key: task.id,
                  staticClass:
                    "flex items-center justify-center flex-shrink-0 w-16 px-2 bg-pure-white"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-center flex-shrink-0 w-12 h-8",
                      class: { "cursor-pointer": !_vm.taskTarget },
                      style: {
                        backgroundColor: _vm.getAverageScore(task)
                          ? task.color
                          : "transparent"
                      },
                      on: {
                        mouseover: function($event) {
                          !_vm.taskTarget && _vm.hoverDetail(task.id)
                        },
                        mouseleave: function($event) {
                          !_vm.taskTarget && _vm.hoverDetail(null)
                        },
                        click: function($event) {
                          !_vm.taskTarget && _vm.selectTask(task)
                        }
                      }
                    },
                    [
                      _vm.taskTarget
                        ? _c(
                            "div",
                            [
                              _c("BlTextBody1", {
                                style: {
                                  color: _vm.getAverageScore(task)
                                    ? "#FFFFFF"
                                    : "#A0A0A0"
                                },
                                attrs: { text: _vm.getAverageScore(task) }
                              })
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              !_vm.isTaskHovered(task.id) && !_vm.taskTarget
                                ? _c("BlTextBody1", {
                                    style: {
                                      color: _vm.getAverageScore(task)
                                        ? "#FFFFFF"
                                        : "#A0A0A0"
                                    },
                                    attrs: { text: _vm.getAverageScore(task) }
                                  })
                                : _vm.isTaskHovered(task.id) && !_vm.taskTarget
                                ? _c("BlIcon", {
                                    staticClass: "w-5 h-5",
                                    attrs: { icon: "square-up", color: "white" }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                    ]
                  )
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dataFormat === "cumulative" || _vm.taskTarget
        ? _c(
            "div",
            { staticClass: "flex flex-shrink-0" },
            _vm._l(_vm.problemBehaviors, function(pb) {
              return _c(
                "div",
                {
                  key: pb.id,
                  staticClass:
                    "flex items-center justify-center flex-shrink-0 w-16 px-2 bg-pure-white"
                },
                [
                  _vm.getRecordProblemBehaviors(pb.id) !== 0
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-center flex-shrink-0 w-12 h-8 cursor-pointer",
                          style: { backgroundColor: pb.color }
                        },
                        [
                          _c("BlTextBody1", {
                            style: { color: "#FFFFFF" },
                            attrs: {
                              text: _vm.getRecordProblemBehaviors(pb.id)
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dataFormat === "distribution"
        ? _c(
            "div",
            { staticClass: "flex flex-col w-full" },
            _vm._l(_vm.problemBehaviors, function(pb, index) {
              return _c(
                "div",
                {
                  key: pb.id,
                  staticClass: "flex items-center w-full",
                  class: {
                    "pt-3": index !== 0,
                    "border-b pb-3": index !== _vm.problemBehaviors.length - 1
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex flex-shrink-0" },
                    _vm._l(_vm.tasks, function(task) {
                      return _c(
                        "div",
                        {
                          key: task.id,
                          staticClass:
                            "flex items-center justify-center flex-shrink-0 w-24 px-2"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center justify-center flex-shrink-0 w-12 h-8 cursor-pointer",
                              style: {
                                backgroundColor: _vm.hasTaskProblemBehavior(
                                  task.id,
                                  pb.id
                                )
                                  ? pb.color
                                  : "transparent"
                              }
                            },
                            [
                              _c("BlTextBody1", {
                                style: {
                                  color: _vm.hasTaskProblemBehavior(
                                    task.id,
                                    pb.id
                                  )
                                    ? "#FFFFFF"
                                    : "transparent"
                                },
                                attrs: {
                                  text: _vm.getTaskProblemBehaviorCount(
                                    task.id,
                                    pb.id
                                  )
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-center flex-shrink-0 w-40 px-2"
                    },
                    [
                      _c("BlTextBody1", {
                        attrs: { title: pb.code, text: pb.code }
                      })
                    ],
                    1
                  )
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dataFormat !== "distribution"
        ? _c(
            "div",
            {
              staticClass:
                "flex items-center flex-shrink-0 w-32 px-2 bg-pure-white"
            },
            [
              !_vm.entry.session || !_vm.entry.session.user
                ? _c("BlTextBody1", {
                    staticClass: "italic truncate",
                    attrs: { title: "Deleted user", text: "Deleted user" }
                  })
                : _c(
                    "router-link",
                    {
                      attrs: {
                        event: _vm.currentUser.role.includes("admin")
                          ? "click"
                          : "",
                        target: "_blank",
                        to: {
                          name: "TeamSessionHistory",
                          params: {
                            user_id: _vm.entry.session.user.id,
                            redirect_target: "/clients/" + _vm.client.id,
                            redirect_label: "Client targets"
                          }
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-center h-8 px-3 truncate border rounded bg-success-100 border-success-100 max-w-25",
                          class: [
                            _vm.currentUser.role.includes("admin")
                              ? "hover:border-success-400"
                              : "cursor-default"
                          ],
                          attrs: { title: _vm.entry.session.user.name }
                        },
                        [
                          _c("BlTextBody1", {
                            staticClass: "truncate text-success",
                            attrs: { text: _vm.entry.session.user.name }
                          })
                        ],
                        1
                      )
                    ]
                  )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dataFormat !== "distribution" && _vm.dataFormat !== "cumulative"
        ? _c(
            "div",
            {
              staticClass:
                "relative flex items-center flex-grow flex-shrink-0 px-2 w-80 bg-pure-white"
            },
            [
              !_vm.taskTarget
                ? _c(
                    "div",
                    {
                      staticClass: "line-clamp-1",
                      attrs: { id: "entry-comment-" + _vm.entry.id }
                    },
                    [
                      _c("BlTextBody1", {
                        attrs: { text: _vm.entry.comment || "-" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "absolute flex right-2 bg-pure-white",
                  style: { opacity: 0, zIndex: 1 },
                  attrs: { id: "entry-view-all-" + _vm.entry.id },
                  on: {
                    click: function($event) {
                      _vm.commentOpened = true
                    }
                  }
                },
                [
                  _c("BlTextBody1", {
                    staticClass: "px-1",
                    attrs: { text: "..." }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center flex-shrink-0 px-2 text-sm font-bold rounded cursor-pointer text-light-purple hover:bg-light-purple-100"
                    },
                    [_vm._v("\n        View all\n      ")]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dataFormat !== "distribution"
        ? _c(
            "div",
            {
              staticClass:
                "relative flex items-center justify-center flex-shrink-0 w-12 px-2 ml-auto bg-pure-white"
            },
            [
              _c(
                "div",
                { staticClass: "relative", attrs: { id: "entry-menu" } },
                [
                  _c("BlInputButton", {
                    staticClass:
                      "flex items-center justify-center w-6 h-6 hover:bg-hover-state",
                    attrs: { icon: "dots-vertical", type: "plain" },
                    on: { clicked: _vm.toggleMenu }
                  }),
                  _vm._v(" "),
                  _vm.menuOpened
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "absolute top-0 z-50 flex flex-col p-1 space-y-1 border rounded right-8 bg-pure-white border-grey-200"
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "px-4 py-2 text-left rounded outline-none hover:bg-hover-state w-44",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.editOpened = true
                                }
                              }
                            },
                            [
                              _c("BlTextBody2", {
                                staticClass: "text-slate-1000",
                                attrs: { text: "Edit record" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.entry.session && _vm.entry.session.slug
                            ? _c(
                                "router-link",
                                {
                                  staticClass:
                                    "px-4 py-2 text-left rounded outline-none hover:bg-hover-state w-44",
                                  attrs: {
                                    to: "/session/" + _vm.entry.session.slug
                                  }
                                },
                                [
                                  _c("BlTextBody2", {
                                    staticClass: "text-slate-1000",
                                    attrs: { text: "See record on session" }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "px-4 py-2 text-left rounded outline-none hover:bg-hover-state w-44",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.deleteOpened = true
                                }
                              }
                            },
                            [
                              _c("BlTextBody2", {
                                staticClass: "text-error-400",
                                attrs: { text: "Delete record" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.commentOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: { title: "Comments", label: "Close", cancelLabel: "Edit" },
              on: {
                "backdrop-close": function($event) {
                  _vm.commentOpened = false
                  _vm.editOpened = true
                },
                "backdrop-action": function($event) {
                  _vm.commentOpened = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "relative px-8 overflow-y-auto",
                  style: { maxHeight: "calc(100vh - 14rem)" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex flex-col" },
                    [
                      _c("BlTextBody2", {
                        staticClass: "flex-wrap break-words w-136",
                        attrs: { text: _vm.entry.comment }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Edit record",
                description:
                  "Editing the record will only affect the data in the table; it will not impact the data recorded during the actual sessions.",
                label: "Save",
                disabled: _vm.submitLoading
              },
              on: {
                "backdrop-close": _vm.onCancelEdit,
                "backdrop-action": _vm.onSave
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex flex-col gap-4 overflow-y-auto w-160",
                  style: { maxHeight: "calc(100vh - 16rem)" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "px-8 space-y-4" },
                    [
                      _c(
                        "div",
                        { staticClass: "grid grid-cols-2 gap-4" },
                        [
                          _c("BlInputDate", {
                            attrs: { input: _vm.recordedAtDatetInput },
                            on: { changed: _vm.inputHandler }
                          }),
                          _vm._v(" "),
                          _c("BlInputDate", {
                            attrs: { input: _vm.recordedAtTimeInput },
                            on: { changed: _vm.inputHandler }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.taskTarget && _vm.dataFormat !== "cumulative"
                        ? _c("BlInputText", {
                            attrs: { input: _vm.commentInput },
                            on: { changed: _vm.inputHandler }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "w-full h-5",
                    staticStyle: { "background-color": "#F9FAFB" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "px-8 space-y-3" },
                    [
                      _c("BlTextSubtitle1", { attrs: { text: "Scores" } }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center gap-3 space-y-2 overflow-x-scroll custom-scrollbar",
                          staticStyle: { "max-width": "calc(100% - 2rem)" }
                        },
                        [
                          _vm._l(_vm.getFilteredTasks(), function(task) {
                            return _c(
                              "div",
                              {
                                key: "task-" + task.id,
                                attrs: { id: "task-id-" + task.id }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col items-center justify-center flex-shrink-0 w-20 p-3 rounded cursor-pointer bg-slate-200"
                                  },
                                  [
                                    _c("BlTextBody1", {
                                      staticClass:
                                        "font-bold text-dark-purple-100",
                                      attrs: { text: _vm.getAverageScore(task) }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody1", {
                                      staticClass: "text-slate-700",
                                      attrs: { text: task.code }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.problemBehaviors, function(pb) {
                            return _c(
                              "div",
                              {
                                key: "pb-" + pb.id,
                                attrs: { id: "pb-id-" + pb.id }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col items-center justify-center flex-shrink-0 p-3 rounded cursor-pointer w-18 bg-slate-200"
                                  },
                                  [
                                    _c("BlTextBody1", {
                                      staticClass: "font-bold text-tomato-700",
                                      attrs: {
                                        text: _vm.getRecordProblemBehaviors(
                                          pb.id
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody1", {
                                      staticClass: "text-slate-700",
                                      attrs: { text: pb.code }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      !_vm.hasScores
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center p-3 rounded bg-cornflower-200"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex gap-2" },
                                [
                                  _c("BlIcon", {
                                    staticClass: "w-5 h-5",
                                    attrs: { icon: "Info-blue" }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass: "text-cornflower-800",
                                    attrs: {
                                      text:
                                        "No trials were recorded during the session, so the scores cannot be modified."
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-col p-3 pr-3 rounded gap-7 bg-slate-200"
                            },
                            _vm._l(_vm.getFilteredScores(), function(score) {
                              return _c(
                                "div",
                                {
                                  key: score.key,
                                  staticClass:
                                    "flex items-center justify-between"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "space-x-3" },
                                    [
                                      _c("BlTextBody2", {
                                        staticClass: "text-slate-800",
                                        attrs: { text: score.key + "." }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        staticClass: "text-slate-800",
                                        attrs: { text: score.task_code }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "flex gap-2" },
                                    [
                                      _c("BlSelectBox", {
                                        staticClass: "w-48",
                                        attrs: {
                                          options: _vm.editPromptsOptions,
                                          position: "top"
                                        },
                                        on: {
                                          change: function(value) {
                                            return _vm.onUpdateScores(
                                              value,
                                              "prompt",
                                              score.key
                                            )
                                          }
                                        },
                                        model: {
                                          value: score.prompt_id,
                                          callback: function($$v) {
                                            _vm.$set(score, "prompt_id", $$v)
                                          },
                                          expression: "score.prompt_id"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlSelectBox", {
                                        staticClass: "w-24",
                                        attrs: {
                                          options: _vm.problemBehaviors.map(
                                            function(pb) {
                                              return {
                                                value: pb.id,
                                                label: pb.code
                                              }
                                            }
                                          ),
                                          placeholder: "-",
                                          position: "top"
                                        },
                                        on: {
                                          change: function(value) {
                                            return _vm.onUpdateScores(
                                              value,
                                              "problem_behavior",
                                              score.key
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            score.target_problem_behavior_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              score,
                                              "target_problem_behavior_id",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "score.target_problem_behavior_id"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            }),
                            0
                          )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c("BlBackdrop", {
            attrs: {
              title: "Delete record",
              label: "Delete",
              description:
                "You are about to delete the record. Are you sure you want to proceed? This action is irreversible.",
              type: "error",
              empty: ""
            },
            on: {
              "backdrop-close": function($event) {
                _vm.deleteOpened = false
              },
              "backdrop-action": _vm.onRemove
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43335734", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43335734","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/EntryPromptSbt.vue
// module id = null
// module chunks = 